import { useContext } from "react"
import { BrindesFornecedorContext } from "./BrindesFornecedorContext"

export function useBrindesFornecedorContext() {
    return useContext(BrindesFornecedorContext)
}
